export const smartRatioOptions = [
    {
        label: '1:1',
        value: '1:1'
    },
    {
        label: '3:1',
        value: '3:1'
    },
    {
        label: '16:9',
        value: '16:9'
    },
    {
        label: '4:3',
        value: '4:3'
    },
    {
        label: '9:16',
        value: '9:16'
    },
    {
        label: '3:2',
        value: '3:2'
    },
    {
        label: '2:1',
        value: '2:1'
    }
];

export const smartRatioSizeOptions = {
    '1:1': [
        {
            label: '600*600',
            value: '600*600'
        },
        {
            label: '240*240',
            value: '240*240'
        },
        {
            label: '220*220',
            value: '220*220'
        },
        {
            label: '360*360',
            value: '360*360'
        },
        {
            label: '480*480',
            value: '480*480'
        },
        {
            label: '300*300',
            value: '300*300'
        }
    ],
    '3:1': [
        {
            label: '1200*400',
            value: '1200*400'
        },
        {
            label: '900*300',
            value: '900*300'
        }
    ],
    '4:3': [
        {
            label: '800*600',
            value: '800*600'
        },
        {
            label: '120*90',
            value: '120*90'
        }
    ],
    '16:9': [
        {
            label: '1140*640',
            value: '1140*640'
        },
        {
            label: '1280*720',
            value: '1280*720'
        },
        {
            label: '1600*900',
            value: '1600*900'
        },
        {
            label: '1920*1080',
            value: '1920*1080'
        }
    ],
    '9:16': [
        {
            label: '1080*1920',
            value: '1080*1920'
        },
        {
            label: '1242*2208',
            value: '1242*2208'
        },
        {
            label: '720*1280',
            value: '720*1280'
        }
    ],
    '3:2': [
        {
            label: '370*245',
            value: '370*245'
        },
        {
            label: '960*640',
            value: '960*640'
        },
        {
            label: '1200*800',
            value: '1200*800'
        },
        {
            label: '900*600',
            value: '900*600'
        },
        {
            label: '300*200',
            value: '300*200'
        }
    ],
    '2:1': [
        {
            label: '800*400',
            value: '800*400'
        },
        {
            label: '600*300',
            value: '600*300'
        }
    ]
};
export const MAX_IMAGE_INPUT_SIZE = 2000;
export const MIN_IMAGE_INPUT_SIZE = 80;
export const MIN_IMAGE_RATIO = 0.3;
export const MAX_IMAGE_RATIO = 3;